let key: string | null = null

export const setKey = (newKey: unknown) => {
  const normalized = typeof newKey === 'string' ? newKey.trim() : ''
  key = normalized.length > 0 ? normalized : null
}

export const clearKey = () => {
  key = null
}

export const hasKey = () => {
  return typeof key === 'string' && key.length > 0
}

export const getKey = () => {
  return key
}
